export const columns = [
  {
    label: 'Nota Fiscal',
    id: 'invoice_number',
    width: 290,
    align: 'center',
  },
  {
    label: 'Valor da Nota',
    id: 'invoice_value',
    width: 140,
    align: 'right',
  },
  {
    label: 'AR',
    id: 'ar_id',
    width: 170,
    align: 'center',
  },
  {
    label: 'Status',
    id: 'status',
    width: 190,
    align: 'center',
  },
  {
    label: 'Boletos',
    id: 'billets_barcode',
    width: 230,
    align: 'center',
  },
  {
    label: 'Tipo',
    id: 'type',
    width: 120,
    align: 'center',
  },
  {
    label: '',
    id: 'actions',
    width: 30,
    align: 'center',
  },
]
